import {
  MAIN_SPONSOR_BRAND,
  MAIN_SPONSOR_ID,
  MAIN_SPONSOR_PRODUCT,
  MAIN_SPONSOR_TAGLINE,
} from '@src/game/MainSponsor';

export {
  MAIN_SPONSOR_BRAND,
  MAIN_SPONSOR_ID,
  MAIN_SPONSOR_PRODUCT,
  MAIN_SPONSOR_TAGLINE,
  presentedBySponsor,
} from '@src/game/MainSponsor';

export interface SponsorCommercial {
  id: string;
  sponsorName: string;
  sponsorTagline: string;
  productName: string;
  slogan: string;
  pitch: string[];
  disclaimer: string;
  rewardText: string;
  badge: string;
  accentColor: string;
  offerSticker: string;
  priceCallout: string;
  /** Station-break chrome. Defaults to the late-night pitchman look. */
  asSeenLabel?: string;
  offerKicker?: string;
  rewardKicker?: string;
  hotlineFlash?: string;
  hotlineText?: string;
  screenTag?: string;
  tickerLines?: string[];
  /** Calms the flashing ORDER-NOW chrome so prestige / doc spots can breathe. */
  tone?: 'pitchman' | 'calm';
  bonus: {
    hp?: number;
    score?: number;
    gems?: number;
  };
}

const FINE_PRINT =
  '*Plus 4 silver pieces shipping & handling via courier bat. Allow 4 to 6 full moons for delivery. Not valid in Nether Realms. Offer void where prohibited by the High Council, sentient furniture, or common sense.';

export const SPONSOR_COMMERCIALS: readonly SponsorCommercial[] = [
  {
    id: 'imp_b_gone',
    sponsorName: 'Brimstone Defense Labs',
    sponsorTagline: 'Official Perimeter Security of Arcane TV',
    productName: 'Imp-B-Gone Repellent',
    slogan: 'One blast. Zero teeth in your robes!',
    pitch: [
      'Are you TIRED of ravenous imps gnawing your silk hemline mid-ritual?!',
      'THROW AWAY your old garlic sachets — Imp-B-Gone blasts pressurized holy citrus vapor!',
      'Call within the next TEN MINUTES and we\'ll DOUBLE the offer!',
    ],
    disclaimer: FINE_PRINT,
    rewardText: '+150 GEMS',
    badge: 'PEST DEFENSE',
    accentColor: '#ff7a1a',
    offerKicker: 'SPECIAL TV OFFER',
    offerSticker: 'DOUBLE THE GEMS',
    priceCallout: '3 PAYMENTS OF 19.99 COPPER',
    bonus: { gems: 150 },
  },
  {
    id: 'gorgon_clear',
    sponsorName: 'Medusa Pharmaceuticals',
    sponsorTagline: 'Trusted Ocular Alchemy Since the Second Age',
    productName: 'Gorgon-Clear Eye Drops',
    slogan: 'Instant relief from unexpected calcification!',
    pitch: [
      'Are you TIRED of eyelids turning to solid granite?!',
      'THROW AWAY those chalky folk remedies — two drops MELTS mineral build-up!',
      'Operators are standing by via scrying orb — ACT NOW!',
    ],
    disclaimer: FINE_PRINT,
    rewardText: '+20 HEALTH',
    badge: 'OCULAR CARE',
    accentColor: '#4af0ff',
    offerKicker: 'FREE SAMPLE',
    offerSticker: 'BONUS DROPS',
    priceCallout: '3 PAYMENTS OF 19.99 COPPER',
    bonus: { hp: 20 },
  },
  {
    id: 'grimoire_care',
    sponsorName: 'The Imperial Underwriters Guild',
    sponsorTagline: 'Securing Contestant Investments Across Seven Realms',
    productName: 'GrimoireCare Wand Warranty',
    slogan: 'Broken wands do NOT win game shows!',
    pitch: [
      'Did a stone golem grind your crystal focus into dust?!',
      'For just twelve silver a month — ZERO deductible, ZERO spell audits!',
      'Call within TEN MINUTES and we\'ll DOUBLE your coverage!',
    ],
    disclaimer: FINE_PRINT,
    rewardText: '+350 SCORE',
    badge: 'FOCUS INSURANCE',
    accentColor: '#b04cff',
    offerKicker: 'GUILD STIPEND',
    offerSticker: 'DOUBLE COVERAGE',
    priceCallout: '3 PAYMENTS OF 19.99 COPPER',
    bonus: { score: 350 },
  },
  {
    id: 'necro_flakes',
    sponsorName: 'Crypt-O-Crunch Mills',
    sponsorTagline: 'Breakfast Partner of the Grand Arena Tour',
    productName: 'Necro-Flakes Cereal',
    slogan: 'Start your morning with cold, crunchy dread!',
    pitch: [
      'Are you TIRED of bland breakfast potions?!',
      'THROW AWAY that sad oatmeal — milled from GENUINE bone meal!',
      'Look for the FREE plastic skull spoon in specially marked boxes!',
    ],
    disclaimer: FINE_PRINT,
    rewardText: '+25 HEALTH',
    badge: 'ARCANE RATIONS',
    accentColor: '#ffd15c',
    offerKicker: 'BOX TOP PRIZE',
    offerSticker: 'SKULL SPOON FREE',
    priceCallout: '3 PAYMENTS OF 19.99 COPPER',
    bonus: { hp: 25 },
  },
  {
    id: 'dungeon_life',
    sponsorName: 'Stygian Mutual Financial',
    sponsorTagline: 'Dignity for the Departed, Gold for the Familiars',
    productName: 'Dungeon-Life Term Assurance',
    slogan: 'You will not clear Room 8. Your familiars might!',
    pitch: [
      'Are you TIRED of leaving your owls BROKE and BEREFT?!',
      '94.2% of contestants perish before floor three — DON\'T gamble!',
      'Call within TEN MINUTES and we\'ll DOUBLE the payout!',
    ],
    disclaimer: FINE_PRINT,
    rewardText: '+120 GEMS',
    badge: 'LIFE ASSURANCE',
    accentColor: '#50e3c2',
    offerKicker: 'POLICYHOLDER DIVIDEND',
    offerSticker: 'DOUBLE THE PAYOUT',
    priceCallout: '3 PAYMENTS OF 19.99 COPPER',
    bonus: { gems: 120 },
  },
  {
    id: 'flame_shield_pomade',
    sponsorName: 'Total Mayhem Broadcast Cosmetics',
    sponsorTagline: 'Look Magnificent on Prime-Time Arcane Television',
    productName: "Vaelen's Flame-Shield Pomade",
    slogan: 'Look immaculate while sprinting for your life!',
    pitch: [
      'Are you TIRED of frizzy hair mid-fireball?!',
      'THROW AWAY that temple grease — locks a razor-sharp side part through DRAGON BREATH!',
      'Forty-eight hour hold — call NOW and we\'ll DOUBLE the tin!',
    ],
    disclaimer: FINE_PRINT,
    rewardText: '+500 SCORE',
    badge: 'STAGE GROOMING',
    accentColor: '#ff3b5c',
    offerKicker: 'VIEWER HYPE',
    offerSticker: 'DOUBLE THE TIN',
    priceCallout: '3 PAYMENTS OF 19.99 COPPER',
    bonus: { score: 500 },
  },
  {
    id: 'ooze_away',
    sponsorName: 'Cube Containment Co.',
    sponsorTagline: 'Industrial Degoo for Adventurers Who Touch Things',
    productName: 'Ooze-Away Slime Dissolver',
    slogan: 'Accidentally hugged a gelatinous cube?!',
    pitch: [
      'DON\'T PANIC — one spritz liquefies dungeon jelly before it etches your boots into soup!',
      'Works on green, purple, and "why-is-it-singing" varieties!',
      'BUT WAIT — THERE\'S MORE! Operators throw in a FREE anti-stick mitt!',
    ],
    disclaimer: FINE_PRINT,
    rewardText: '+180 GEMS',
    badge: 'SLIME CONTROL',
    accentColor: '#39ff88',
    offerKicker: 'CLEANUP REBATE',
    offerSticker: 'FREE ANTI-STICK MITT',
    priceCallout: '3 PAYMENTS OF 19.99 COPPER',
    bonus: { gems: 180 },
  },
  {
    id: 'gargoyle_grit',
    sponsorName: 'Bastion Bite Athletics',
    sponsorTagline: 'Fuel for Mages Who Skip Hydration Entirely',
    productName: 'Gargoyle-Grit Mana Crunch',
    slogan: 'Pre-workout gravel for battle mages!',
    pitch: [
      'Are you TIRED of soft mana potions?!',
      'THROW AWAY that watery elixir — pulverized roost-stone and POWDERED LIGHTNING!',
      'Call NOW and get a second pouch of Extra-Grit FREE!',
    ],
    disclaimer: FINE_PRINT,
    rewardText: '+30 HEALTH',
    badge: 'MANA FUEL',
    accentColor: '#c4a574',
    offerKicker: 'TRAINING PACK',
    offerSticker: 'EXTRA-GRIT FREE',
    priceCallout: '3 PAYMENTS OF 19.99 COPPER',
    bonus: { hp: 30 },
  },
  {
    id: 'banshee_b_quiet',
    sponsorName: 'Silence & Sons Spectral Audio',
    sponsorTagline: 'Hearing Protection Endorsed by Nervous Apprentices',
    productName: 'Banshee-B-Quiet Spectral Muffs',
    slogan: 'Active death-rattle cancellation!',
    pitch: [
      'Are you TIRED of wails that crack crystal foci AND your will to live?!',
      'THROW AWAY those beeswax plugs — phase-shift screams into distant sobbing!',
      'As seen on Arcane TV — order before the next shriek!',
    ],
    disclaimer: FINE_PRINT,
    rewardText: '+400 SCORE',
    badge: 'SONIC RELIEF',
    accentColor: '#9b7bff',
    offerKicker: 'QUIET HOURS',
    offerSticker: 'SCREAM SHIELD',
    priceCallout: '3 PAYMENTS OF 19.99 COPPER',
    bonus: { score: 400 },
  },
  {
    id: 'cursed_ring_butter',
    sponsorName: 'Hex & Hoax Household',
    sponsorTagline: 'Emergency Lubricants for Binding Jewelry Situations',
    productName: 'Cursed Ring Butter',
    slogan: 'Emergency lubrication for binding finger jewelry!',
    pitch: [
      'That cursed band TIGHTENING every time you tell a white lie?!',
      'THROW AWAY the pliers — one dab and it SLIDES OFF like a polite apology!',
      'Limited jars — ACT NOW or stay CURSED FOREVER!',
    ],
    disclaimer: FINE_PRINT,
    rewardText: '+140 GEMS',
    badge: 'CURSE CARE',
    accentColor: '#ffb347',
    offerKicker: 'LIMITED JARS',
    offerSticker: 'SLIDES RIGHT OFF',
    priceCallout: '3 PAYMENTS OF 19.99 COPPER',
    bonus: { gems: 140 },
  },
  {
    id: 'instant_hydra',
    sponsorName: 'Pocket Menagerie Ltd.',
    sponsorTagline: 'Loyal Backup Heads Delivered Fresh to Your Belt',
    productName: 'Instant-Hydra Pocket Pouch',
    slogan: 'Just add blood — three heads in five seconds!',
    pitch: [
      'Are you TIRED of fighting alone?! Ambush incoming?! TEAR! SPLASH! DEPLOY!',
      'Each head argues about tactics so YOU never have to!',
      'Call within TEN MINUTES and we\'ll DOUBLE the heads!',
    ],
    disclaimer: FINE_PRINT,
    rewardText: '+35 HP  ·  +250 SCORE',
    badge: 'SUMMON SNACK',
    accentColor: '#ff4d6d',
    offerKicker: 'FAMILIAR STIPEND',
    offerSticker: 'DOUBLE THE HEADS',
    priceCallout: '3 PAYMENTS OF 19.99 COPPER',
    bonus: { hp: 35, score: 250 },
  },
  {
    id: 'veil_no_5',
    sponsorName: 'Maison Ossuary',
    sponsorTagline: 'Fragrance for those already beyond',
    productName: 'Veil No. 5',
    slogan: 'You cannot afford it. That is the point.',
    pitch: [
      'Veil Number Five. For the wizard who has already died once.',
      'Notes of crypt lily, old gold, and the last thing a basilisk saw.',
      'Maison Ossuary. A private consultation, if they like your bones.',
    ],
    disclaimer:
      '*Available by appointment. Maison Ossuary does not accept copper, compliments, or hope. Vials evaporate if discussed at a reasonable volume.',
    rewardText: '+400 SCORE',
    badge: 'HAUTE NECROMANCY',
    accentColor: '#c9a96e',
    offerKicker: 'PRIVATE COLLECTION',
    offerSticker: 'LIMITED VIALS',
    priceCallout: 'PRICE UPON CONSULTATION',
    asSeenLabel: 'MAISON OSSUARY',
    rewardKicker: 'COURTESY SAMPLE',
    hotlineFlash: 'BY APPOINTMENT',
    hotlineText: 'MAISON OSSUARY  //  INQUIRIES VIA RAVEN ONLY',
    screenTag: 'MAISON FEED // MOONLIGHT',
    tickerLines: [
      'BY APPOINTMENT ONLY',
      'NOTES OF CRYPT LILY AND OLD GOLD',
      'YOU CANNOT AFFORD IT',
      'THAT IS THE POINT',
    ],
    tone: 'calm',
    bonus: { score: 400 },
  },
  {
    id: 'roost_relish',
    sponsorName: 'Arcane Geographic',
    sponsorTagline: 'Filmed at a respectful distance',
    productName: 'Roost & Relish Familiar Chow',
    slogan: 'Do not make eye contact. It remembers.',
    pitch: [
      'In the last light, the common arena raven performs a rare ritual.',
      'It is called dinner.',
      'Roost and Relish. Formulated by people who have, at least once, met a bird.',
    ],
    disclaimer:
      '*Do not feed wild familiars from your pocket. Roost & Relish is not liable for stolen hats, rings, or last names.',
    rewardText: '+160 GEMS',
    badge: 'WILDLIFE RATION',
    accentColor: '#d4a017',
    offerKicker: 'FIELD NOTE',
    offerSticker: 'AS SEEN IN THE WILD',
    priceCallout: 'SELECT SANCTUARIES',
    asSeenLabel: 'ARCANE GEOGRAPHIC',
    rewardKicker: 'FIELD GRANT',
    hotlineFlash: 'DO NOT APPROACH',
    hotlineText: 'FILMED AT A RESPECTFUL DISTANCE  //  DO NOT FEED THE SUBJECT',
    screenTag: 'ARCANE GEOGRAPHIC // HIDE 4',
    tickerLines: [
      'DO NOT MAKE EYE CONTACT',
      'IT REMEMBERS',
      'FORMULATED BY PEOPLE WHO HAVE MET A BIRD',
      'KEEP YOUR HAT ON',
    ],
    tone: 'calm',
    bonus: { gems: 160 },
  },
  {
    id: 'module_seven',
    sponsorName: 'Dept. of Arcane Compliance',
    sponsorTagline: 'Making incidents easier to file',
    productName: 'Regulation Orange Portal Cones',
    slogan: 'They do not stop the portal.',
    pitch: [
      'Welcome to Arcane Compliance Module Seven. Portals.',
      'If it hums, do not put your hand in it.',
      'These cones do not stop the portal. They make the incident easier to file.',
    ],
    disclaimer:
      '*Viewing this module does not constitute training. Please initial form 7-B. And 7-C. And the waiver under the wilted fern.',
    rewardText: '+130 GEMS',
    badge: 'MANDATORY VIEWING',
    accentColor: '#e67a22',
    offerKicker: 'ISSUED TODAY',
    offerSticker: 'REQUISITION 7-B',
    priceCallout: 'ISSUED, NOT SOLD',
    asSeenLabel: 'REQUIRED VIEWING',
    rewardKicker: 'COMPLIANCE CREDIT',
    hotlineFlash: 'INITIAL HERE',
    hotlineText: 'DEPT. OF ARCANE COMPLIANCE  //  PLEASE INITIAL FORM 7-B',
    screenTag: 'TRAINING TAPE // MODULE 7',
    tickerLines: [
      'IF IT HUMS DO NOT PUT YOUR HAND IN IT',
      'PLEASE INITIAL FORM 7-B',
      'THE CONES DO NOT STOP THE PORTAL',
      'THIS MODULE IS MANDATORY',
    ],
    tone: 'calm',
    bonus: { gems: 130 },
  },
  {
    id: 'lil_lich',
    sponsorName: "The Lil' Lich Hour",
    sponsorTagline: 'Educational necromancy for small bones',
    productName: 'My First Phylactery',
    slogan: 'A box for your soul. Not for snacks.',
    pitch: [
      'Hi friends! Today we learned a big word. Phylactery!',
      'That is a box you keep your soul in so you can come back after nap time.',
      'Ask a grown necromancer. Do not eat the glitter.',
    ],
    disclaimer:
      '*Grown necromancers only. Phylacteries are not lunchboxes. Glitter is not a food group. If your soul falls out, sit quietly until a teacher arrives.',
    rewardText: '+25 HEALTH',
    badge: "TODAY'S WORD",
    accentColor: '#7ec8e3',
    offerKicker: 'CRAFT TIME',
    offerSticker: 'PHYLACTERY',
    priceCallout: 'ASK A GROWN-UP',
    asSeenLabel: "LIL' LICH HOUR",
    rewardKicker: 'CRAFT TIME',
    hotlineFlash: 'CRAFT TIME',
    hotlineText: 'ASK A GROWN NECROMANCER  //  GLITTER IS NOT A SNACK',
    screenTag: "LIL' LICH HOUR // TODAY'S WORD",
    tickerLines: [
      'TODAY WE LEARNED A BIG WORD',
      'PHYLACTERY',
      'DO NOT EAT THE GLITTER',
      'ASK A GROWN NECROMANCER',
    ],
    tone: 'calm',
    bonus: { hp: 25 },
  },
  {
    id: 'bone_appetit',
    sponsorName: 'Bone Appétit Kitchen',
    sponsorTagline: 'Stock from skeletons who signed the release',
    productName: 'Sixty-Second Skeleton Stock',
    slogan: 'Reduces to silk. Serves twelve. Or one lich.',
    pitch: [
      'Tonight we are making stock. The polite kind.',
      'From a skeleton who signed the release.',
      'Sixty-Second Skeleton Stock. Bone appetit.',
    ],
    disclaimer:
      '*Not a substitute for bones you knew personally. Simmer, do not scream. Chef is a volunteer and would like his femur back by Thursday.',
    rewardText: '+20 HP  ·  +180 SCORE',
    badge: 'NOW SIMMERING',
    accentColor: '#e8c07a',
    offerKicker: 'TONIGHT',
    offerSticker: 'NOW SIMMERING',
    priceCallout: 'SERVES 12 OR 1 LICH',
    asSeenLabel: 'BONE APPÉTIT',
    rewardKicker: 'TASTING SPOON',
    hotlineFlash: 'BONE APPÉTIT',
    hotlineText: 'NOW SIMMERING  //  SERVES TWELVE OR ONE VERY PATIENT LICH',
    screenTag: 'STUDIO KITCHEN // LIVE STEAM',
    tickerLines: [
      'THE POLITE KIND OF STOCK',
      'FROM A SKELETON WHO SIGNED THE RELEASE',
      'REDUCES TO SILK',
      'BONE APPETIT',
    ],
    tone: 'calm',
    bonus: { hp: 20, score: 180 },
  },
  {
    id: 'follicore',
    sponsorName: 'Crown & Recede Labs',
    sponsorTagline: 'Official Hairline of Arcane TV',
    productName: 'Follicore',
    slogan: 'Your rival kept the hat on for a reason.',
    pitch: [
      'Are you TIRED of lich-pattern baldness ruining your close-up?!',
      'THROW AWAY that sad pointed hat — Follicore grows a FULL MANE while the imps are STILL laughing!',
      'Call NOW or keep losing to a wizard who can still part his hair!',
    ],
    disclaimer: FINE_PRINT,
    rewardText: '+400 SCORE',
    badge: 'HAIRLINE DEFENSE',
    accentColor: '#e8b84a',
    offerKicker: 'SPECIAL TV OFFER',
    offerSticker: 'KEEP THE HAT OFF',
    priceCallout: '3 PAYMENTS OF 19.99 COPPER',
    tickerLines: [
      'YOUR RIVAL KEPT THE HAT ON FOR A REASON',
      'LICH-PATTERN BALDNESS IS NOT A BATTLE SCAR',
      'IMPS ARE ALREADY POINTING',
      'KEEP THE HAT OR KEEP THE HAIR',
    ],
    bonus: { score: 400 },
  },
  {
    id: MAIN_SPONSOR_ID,
    sponsorName: MAIN_SPONSOR_BRAND,
    sponsorTagline: 'Official lager of the Grand Arena',
    productName: MAIN_SPONSOR_PRODUCT,
    slogan: MAIN_SPONSOR_TAGLINE,
    pitch: [
      'When the gates open, a thousand wizards lift one stein.',
      'That is not a spell. That is a promise.',
      MAIN_SPONSOR_TAGLINE,
    ],
    disclaimer:
      `*Toast responsibly. ${MAIN_SPONSOR_BRAND} is a fantasy lager. Not for familiars under three centuries. Bone horses are union. Frogs are non-union and extremely proud.`,
    rewardText: '+200 GEMS',
    badge: 'OFFICIAL LAGER',
    accentColor: '#e3b341',
    offerKicker: 'STADIUM TOAST',
    offerSticker: "THIS ONE'S FOR YOU",
    priceCallout: 'THE WORKING MAGE\'S GOLD',
    asSeenLabel: MAIN_SPONSOR_BRAND.toUpperCase(),
    rewardKicker: 'TOAST BONUS',
    hotlineFlash: 'RAISE A STEIN',
    hotlineText: `${MAIN_SPONSOR_BRAND.toUpperCase()}  //  OFFICIAL LAGER OF THE GRAND ARENA`,
    screenTag: `${MAIN_SPONSOR_BRAND.toUpperCase()} // STADIUM FEED`,
    tickerLines: [
      'OFFICIAL LAGER OF THE GRAND ARENA',
      'THE BONE HORSES KNOW THE TOAST',
      'EVEN THE FROGS KNOW',
      MAIN_SPONSOR_TAGLINE.toUpperCase(),
    ],
    tone: 'calm',
    bonus: { gems: 200 },
  },
];

let lastSponsorIndex = -1;

export function commercialById(id: string): SponsorCommercial | undefined {
  return SPONSOR_COMMERCIALS.find((c) => c.id === id);
}

export function pickNextCommercial(): SponsorCommercial {
  let idx = Math.floor(Math.random() * SPONSOR_COMMERCIALS.length);
  if (idx === lastSponsorIndex && SPONSOR_COMMERCIALS.length > 1) {
    idx = (idx + 1) % SPONSOR_COMMERCIALS.length;
  }
  lastSponsorIndex = idx;
  return SPONSOR_COMMERCIALS[idx];
}
